module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_07.b2122dc5.png";